import React from 'react';
import closeButtonStyles from './closeButton.module.pcss';

interface CloseButtonProps {
  handleClick: () => void;
}

function CloseButton({ handleClick }: CloseButtonProps): React.ReactElement {
  return (
    <button className={closeButtonStyles['close-button']} type="button" onClick={handleClick}>
      <div className={closeButtonStyles['close-button__lines']}>
        <div className={`${closeButtonStyles['close-button__line']} ${closeButtonStyles['close-button__line--1']}`} />
        <div className={`${closeButtonStyles['close-button__line']} ${closeButtonStyles['close-button__line--2']}`} />
      </div>
    </button>
  );
}

export default CloseButton;
